export enum DeclaredUnit {
  piece = 'piece',
  liter = 'liter',
  kilogram = 'kilogram',
  cubicMeter = 'cubic_meter',
  kilowattHour = 'kilowatt_hour',
  megajoule = 'megajoule',
  tonKilometer = 'ton_kilometer',
  squareMeter = 'square_meter',
}

export enum CalculationDeclaredUnit {
  kilogram = DeclaredUnit.kilogram,
  piece = DeclaredUnit.piece,
  liter = DeclaredUnit.liter,
  squareMeter = DeclaredUnit.squareMeter,
}

export const DeclaredUnitToPlainSymbolsMap = {
  [DeclaredUnit.piece]: 'piece',
  [DeclaredUnit.liter]: 'L',
  [DeclaredUnit.kilogram]: 'kg',
  [DeclaredUnit.cubicMeter]: 'm³',
  [DeclaredUnit.kilowattHour]: 'kWh',
  [DeclaredUnit.megajoule]: 'MJ',
  [DeclaredUnit.tonKilometer]: 'tkm',
  [DeclaredUnit.squareMeter]: 'm²',
};

interface IProductOrSectorSpecificRule {
  ruleName: string;
}

interface IProductOrSectorSpecificRules {
  extWBCSD_operator: string;
  productOrSectorSpecificRules: IProductOrSectorSpecificRule[];
  extWBCSD_otherOperatorName: string;
}

interface ISecondaryEmissionFactorSource {
  secondaryEmissionFactorSource: string;
}

export interface ICrossSectoralStandardsUsedV2 {
  crossSectoralStandard: string;
}

interface ICarbonFootprint {
  id: string;
  declaredUnit: DeclaredUnit;
  unitaryProductAmount: number;
  productMassPerDeclaredUnit: number;
  exemptedEmissionsPercent: number;
  geographyRegionOrSubregion: string;
  geographyCountry?: string;
  referencePeriodStart: string; // ISO date string
  referencePeriodEnd: string; // ISO date string
  crossSectoralStandardsUsed: ICrossSectoralStandardsUsedV2[];
  productOrSectorSpecificRules: IProductOrSectorSpecificRules[];
  extWBCSD_characterizationFactors: string;
  extTFS_allocationWasteIncineration: string;
  secondaryEmissionFactorSources: ISecondaryEmissionFactorSource[];
  extWBCSD_packagingEmissionsIncluded?: boolean;
  pcfExcludingBiogenic: number;
  pcfIncludingBiogenic: number;
  carbonContentBiogenic: number;
  carbonContentTotal: number;
  extWBCSD_fossilCarbonContent: number;
}

export interface IComponentDetails {
  id: number;
  productIds: string[];
  productDescription: string;
  productName: string;
  companyName: string;
  companyIds: string[];
  pcfLegalStatement?: string;
  created: string; // ISO date string
  pcf: ICarbonFootprint;
  ownProductId?: string;
  ownProductName?: string;
  otherRequestData?: {
    component_name: string;
    component_id: string;
  };
  restricted?: boolean;
}
